module.exports = __webpack_public_path__ + "static/img/jclb4.e23566d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jclb4.png
// module id = p7Q2
// module chunks = 1